export default __webpack_public_path__ + "static/media/scissors-teaser-fast.af13f63b.gif";